import { render } from "./dashboard-topbar.vue?vue&type=template&id=bacfe47c"
import script from "./dashboard-topbar.vue?vue&type=script&lang=js"
export * from "./dashboard-topbar.vue?vue&type=script&lang=js"

import "./dashboard-topbar.vue?vue&type=style&index=0&id=bacfe47c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__